import styled from "styled-components";

export const ContainerBody = styled.div`
  padding: 0rem 6rem;

  @media(max-width: 770px) {
    padding: 0rem;
  }
`;

export const AreaTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;

  img {
    width: 10%;
  }
`;


export const DebtMessageTime = styled.p`
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
  font-weight: bold;
  text-align: center;
  color: #707070;
`;

export const BottomMessage = styled.p`
  text-align: center;
  color: #707070;
`;

export const BottomMessageAccess = styled.p`
  margin-bottom: 1rem;
  text-align: center;
  color: #707070;
`;

export const InstructionMessage = styled.p`
  text-align: center;
  color: #112efc;
`;

export const CardItem = styled.div`
  margin: 0.5rem 1rem;
`;

export const AreaItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const AreaHeaderItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0rem 1rem 0rem 1rem;
`;

export const AreaItemLeft = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const AreaItemRigth = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: right;
  align-items: center;

`;

export const DescriptionHeaderTitleItem = styled.div`
  padding: 1rem;
  font-size: .88rem;
  font-weight: bold;
  color: #707070;

  @media(max-width: 770px) {
    padding: 0.5rem;
  }
`;

export const DescriptionTitleItem = styled.div`
  padding: 1rem;
  font-size: .88rem;
  font-weight: bold;
  color: #464eff;

  @media(max-width: 770px) {
    padding: 0.5rem;
  }
`;

export const DescriptionItem = styled.div`
  padding: 1rem;
  font-size: .88rem;
  font-weight: bold;
  color: #707070;

  @media(max-width: 770px) {
    padding: 0.5rem;
  }
`;

export const DescriptionItemTitle = styled.div`
  padding: 1rem;
  font-size: .88rem;
  font-weight: bold;
  color: #707070;
  margin-right: 2rem;

  @media(max-width: 770px) {
    padding: 0.5rem;
  }
`;

export const ButtonDivision = styled.div`
  width: 50%;
  margin: 1rem auto 0rem auto;

  @media(max-width: 600px) {
    width: 100%;
  }
`;

export const ButtonOutline = styled.button`
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  width: 100%;
  height: 38px;
  background-color: ${(props) => (props.outline ? "transparent" : "#000FFF")};
  border-radius: 10px;
  color: ${(props) => (props.outline ? "#000FFF" : "#ffffff")};
  text-align: center;
  border: ${(props) => (props.outline ? "2px solid #000FFF" : "0")};
  overflow: hidden;
  box-shadow: ${(props) => (props.outline ? "0px 3px 8px #00000040" : "0px 3px 8px #00000059")};
  border-radius: ${(props) => (props.outline ? "8px" : "10px")};
  transition: 0.5s;
  &:hover {
    filter: brightness(85%);
  }
  img {
    float: left;
    padding-left: 0.7rem;
  }
  span {
    padding-right: 1.1rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
